import { createRootRouteWithContext, redirect } from '@tanstack/react-router';

import { type RouterContext } from '~/types/router.type';

import {
  BAYWA_SCREEN_USER,
  SUPPLIER_OVERVIEW_USER,
} from '~/data/user/constants';

import { RootLayout } from '~/modules/appInitializer';

import { getLegacyRedirectPath } from '~/utils/routeUtils';

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
  beforeLoad(ctx) {
    // * Manage global redirects here without creating a separate route file

    const { auth } = ctx.context;
    const userId = auth.getUserIdFromAccessToken();

    // Check if user is external supplier (redirect to external-supplier page)
    if (
      userId &&
      SUPPLIER_OVERVIEW_USER.includes(userId) &&
      ctx.location.pathname !== '/external-supplier'
    ) {
      redirect({
        to: '/external-supplier',
        throw: true,
      });
    }

    // Check if user is special-purpose BayWa user for pick-up screen
    if (
      userId &&
      userId === BAYWA_SCREEN_USER &&
      ctx.location.pathname !== '/pickup'
    ) {
      redirect({
        to: '/pickup',
        throw: true,
      });
    }

    if (ctx.location.pathname === '/dashboard')
      redirect({
        to: '/analytics',
        throw: true,
      });

    // Handle legacy route redirects from react-router migration
    const legacyRedirectPath = getLegacyRedirectPath(ctx.location.pathname);
    if (legacyRedirectPath) {
      redirect({
        to: legacyRedirectPath,
        search: ctx.location.search,
        throw: true,
      });
    }
  },
});
